<div class="product-view-dialog">
  <div *ngIf="data.productEntries && data.productEntries.length > 0" class="debit-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Ledger Name</th>
          <th>Product/Service Name</th>
          <th>After Discount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of data.productEntries; let i = index">
          <td>{{ i + 1 }}</td>
          <td >{{ product.ledger_name }}</td>
          <td>{{ getProductTypeName(product.productType) }}</td>
          <td>{{ calculateDiscount(product.qty, product.unitPrice, product.discount) | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="tables-container">
      <div class="voucher-row">
        <table class="voucher-table">
          <thead>
            <tr>
              <th colspan="2">Debit</th>
            </tr>
            <tr>
              <th>Ledger Name</th>
              <th>Total After Discount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="data.voucher === 'Purchase'">
              <tr *ngFor="let ledger of getGroupedLedgers(); let i = index">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalDiscountedAmount | number:'1.2-2' }}</td>
              </tr>
              <tr *ngFor="let ledger of getGroupedGstDetails()">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Up'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          
            <ng-container *ngIf="data.voucher === 'Sales'">
              <tr>
                <td> {{ data.selectedCustomerBranchLedgerName }}</td>
                <td>{{ getTotalRoundedAmount() | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Down'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <table class="voucher-table">
          <thead>
            <tr>
              <th colspan="2">Credit</th>
            </tr>
            <tr>
              <th>Ledger Name</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="data.voucher === 'Sales'">
              <tr *ngFor="let ledger of getGroupedLedgers(); let i = index">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalDiscountedAmount | number:'1.2-2' }}</td>
              </tr>
              <tr *ngFor="let ledger of getGroupedGstDetails()">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Up'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          
            <ng-container *ngIf="data.voucher === 'Purchase'">
              <tr>
                <td>{{ data.selectedVendorBranchLedgerName }}</td>
                <td>{{ getTotalRoundedAmount() | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Down'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="totals">
      <div>Sub Total Amount: {{ data.totalAmount | number:'1.2-2' }}</div>
      <div>Total GST Amount: {{ data.totalGSTAmount | number:'1.2-2' }}</div>
      <div>Total Amount: {{ data.totalAmount + data.totalGSTAmount | number:'1.2-2' }}</div>
      <div *ngIf="data.round_up !== null">Round {{ data.round_up < 0 ? 'Down' : (data.round_up > 0 ? 'Up' : '') }} Amount: {{ data.round_up | number: '1.2-2' }}</div> 
      <div>Total Credit: {{data.total_cr | number:'1.2-2'}}</div>
      <div>Total Debit: {{ data.total_dr | number:'1.2-2'}}</div>
    </div>
    <div>

      <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
    </div>
  </div>
  <!-- product list Grn -->
  <div *ngIf="data.productList && data.productList.length > 0" class="debit-table">
    <table>
      <thead>
        <tr>
          <!-- <th>Sl.No</th> -->
          <!-- <th *ngIf="!hasFixedAsset">Ledger Name</th> -->
          <!-- <th>Sl.No</th> -->
          <th>Ledger Name</th>
          <th>Product/Service Name</th>
          <th>After Discount</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of data.productList; let i = index">
          <tr *ngFor="let detail of product.details">
          <!-- <td>{{ i + 1 }}</td> -->
          <td *ngIf="data?.grn?.length > 0 && detail.item_service_type !== 'Fixed Asset'">
            {{ getLedgerName(detail, data.voucher) }}
          </td>
          <td *ngIf="data?.gsn?.length > 0 && detail.item_service_type !== 'Fixed Asset'">
            {{ getLedgerName(detail, data.voucher) }}
          </td>
            <!-- <td *ngIf="data?.grn?.length > 0">
              {{detail?.sku?.sku_name}}
            </td> -->
          <td>
              <!-- {{detail?.item_service_type === 'SKU' ? detail?.sku?.sku_name : detail?.service?.service_name}} -->
            {{
              detail.item_service_type === 'SKU'
                ? detail?.sku?.sku_name
                : detail.item_service_type === 'Service'
                ? detail?.service?.service_name
                : detail.item_service_type === 'Fixed Asset'
                ? detail?.fa_template?.name
                : ''
            }}
          </td>
          <td *ngIf="data?.grn?.length > 0">
            {{calculateDiscount(detail.receive_qty, detail.unit_price, 0, 0) | number:'1.2-2'}}
          </td>
          <td *ngIf="data?.gsn?.length > 0">
            {{calculateDiscount(detail.send_qty, detail.unit_price, detail.discount_amount,detail.incentive_amount) | number:'1.2-2'}}
          </td>
        </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="tables-container">
      <div class="voucher-row">
        <table class="voucher-table">
          <thead>
            <tr>
              <th colspan="3">Debit</th>
            </tr>
            <tr>
              <th>Ledger Name</th>
              <th>Total After Discount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="data.voucher === 'Purchase'">
              <tr *ngFor="let ledger of uniqueLedgerIds2(); let i = index">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalDiscountedAmount | number:'1.2-2' }}</td>
              </tr>
              <ng-container *ngIf="data.gst_type === 'REGISTER'">
                <tr *ngFor="let item of getGroupedGstLedgers()">
                  <td>{{ item.ledgerName }}</td>
                  <td>{{ item.gstAmount | number:'1.2-2' }}</td>
                </tr>
              </ng-container>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Up'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          
            <ng-container *ngIf="data.voucher === 'Sales'">
              <tr>
                <td> {{ data.selectedCustomerBranchLedgerName }}</td>
                <td>{{ getTotalRoundedAmount() | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Down'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <table class="voucher-table">
          <thead>
            <tr>
              <th colspan="2">Credit</th>
            </tr>
            <tr>
              <th>Ledger Name</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="data.voucher === 'Sales'">
              <tr *ngFor="let ledger of uniqueLedgerIds2(); let i = index">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalDiscountedAmount | number:'1.2-2' }}</td>
              </tr>
              <ng-container *ngIf="data.gst_type === 'REGISTER'">
              <tr *ngFor="let item of getGroupedGstLedgers()">
                <td>{{ item.ledgerName }}</td>
                <td>{{ item.gstAmount | number:'1.2-2' }}</td>
              </tr>
              </ng-container>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Up'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          
            <ng-container *ngIf="data.voucher === 'Purchase'">
              <tr>
                <td>{{ data.selectedVendorBranchLedgerName }}</td>
                <td>{{ getTotalRoundedAmount() | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="data.round_up !== null && data.round_label === 'Down'">
                <td>{{ data.rounded_ledger }}</td>
                <td>{{ data.round_up | number:'1.2-2' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="totals">
      <div>Sub Total Amount: {{ data.totalAmount | number:'1.2-2' }}</div>
      <div>Total GST Amount: {{ data.totalGSTAmount | number:'1.2-2' }}</div>
      <div>Total Amount: {{ data.totalAmount + data.totalGSTAmount | number:'1.2-2' }}</div>

      <div *ngIf="data.round_up !== null">Round {{ data.round_label }} Amount: {{ data.round_up | number: '1.2-2' }}</div> 
      <div>Total Credit: {{data.total_cr | number:'1.2-2'}}</div>
      <div>Total Debit: {{ data.total_dr | number:'1.2-2'}}</div>
    </div>
    <div>
      <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
    </div>
  </div>

<div *ngIf="data.type === 'inventory' " class="debit-table">
  <h3>SKU Inventory Summary</h3>
  <table border="1" style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr>
        <th>Sl. No</th>
        <th>SKU Name</th>
        <th>sku Price</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sku of data.tableSkus; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ sku.sku?.sku_name }}</td>
        <td>{{ data.skuPrices[i]?.amount | number: '1.2-2' }}</td>
      </tr>
    </tbody>
  </table>

  <br>

  <!-- Debit and Credit Breakdown -->
  <div style="display: flex; justify-content: space-between; margin-top: 20px;">
    <!-- Debit -->
    <div style="width: 48%;">
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th colspan="3">Debit</th>
          </tr>
          <tr>
            <th>Debit Ledger</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data.dr">
            <td>{{ d.ledger_name }}</td>
            <td>{{ d.amount }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Credit -->
    <div style="width: 48%;">
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th colspan="3">Credit</th>
          </tr>
          <tr>
            <th>Credit Ledger</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of data.cr">
            <td>{{ c.ledger_name }}</td>
            <td>{{ c.amount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
  </div>
</div>

<div *ngIf="data.voucher === 'Credit Note' &&data.InvoiceType === 'sales'" class="debit-table">
  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Ledger Name</th>
        <th>Product/Service Name</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ledger of data.productDetails; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ ledger.product_ledger_name }}</td>
        <td>{{ ledger.product_name}}</td>
        <td>{{ ledger.change_value | number:'1.2-2' }}</td>
      </tr>
    </tbody>
  </table>
  <div class="tables-container">
    <div class="voucher-row">
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="3">Debit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let ledger of data.productarray; let i = index">
              <td>{{ ledger.product_ledger_name }}</td>
              <td>{{ ledger.change_value | number:'1.2-2' }}</td>
            </tr>
             <tr *ngFor="let ledger of getGroupedGstDetails()">
                <td>{{ ledger.ledger_name }}</td>
                <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
              </tr>
          </ng-container>
        </tbody>
      </table>
      <table class="voucher-table">
        <thead> 
          <tr>
            <th colspan="2">Credit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr>
              <td>{{ data.CustomerBranchLedgerName }}</td>
              <td>{{ (data.CustomerAmount + getTotalGstAmount()) | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
  </div>
</div>

<div *ngIf="data.voucher === 'Debit Note' && data.InvoiceType === 'sales'" class="debit-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Ledger Name</th>
          <th>Product/Service Name</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ledger of data.productDetails; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ ledger.product_ledger_name }}</td>
          <td>{{ ledger.product_name}}</td>
          <td>{{ ledger.change_value | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  <div class="tables-container">
    <div class="voucher-row">
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="2">Dedit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr>
              <td>{{ data.CustomerBranchLedgerName }}</td>
              <td>{{ (data.CustomerAmount + getTotalGstAmount()) | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="3">Credit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let ledger of data.productarray; let i = index">
              <td>{{ ledger.product_ledger_name }}</td>
              <td>{{ ledger.change_value | number:'1.2-2' }}</td>
            </tr>
            <tr *ngFor="let ledger of getGroupedGstDetails()">
              <td>{{ ledger.ledger_name }}</td>
              <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
  </div>
</div>

<div *ngIf="data.voucher === 'Debit Note' && data.InvoiceType === 'purchase'" class="debit-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Ledger Name</th>
          <th>Product/Service Name</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ledger of data.productDetails; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ ledger.product_ledger_name }}</td>
          <td>{{ ledger.product_name}}</td>
          <td>{{ ledger.change_value | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  <div class="tables-container">
    <div class="voucher-row">
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="3">Debit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr>
              <td>{{ data.VendorBranchLedgerName }}</td>
              <td>{{ (data.VendorAmount + getTotalGstAmount()) | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="2">Credit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let ledger of data.productarray; let i = index">
              <td>{{ ledger.product_ledger_name }}</td>
              <td>{{ ledger.change_value | number:'1.2-2' }}</td>
            </tr>
            <tr *ngFor="let ledger of getGroupedGstDetails()">
              <td>{{ ledger.ledger_name }}</td>
              <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
  </div>
</div>

<div *ngIf="data.voucher === 'Credit Note' && data.InvoiceType === 'purchase'" class="debit-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Ledger Name</th>
          <th>Product/Service Name</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ledger of data.productDetails; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ ledger.product_ledger_name }}</td>
          <td>{{ ledger.product_name}}</td>
          <td>{{ ledger.change_value | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  <div class="tables-container">
    <div class="voucher-row">
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="2">Dedit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let ledger of data.productarray; let i = index">
              <td>{{ ledger.product_ledger_name }}</td>
              <td>{{ ledger.change_value | number:'1.2-2' }}</td>
            </tr>
            <tr *ngFor="let ledger of getGroupedGstDetails()">
              <td>{{ ledger.ledger_name }}</td>
              <td>{{ ledger.totalAmount | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <table class="voucher-table">
        <thead>
          <tr>
            <th colspan="3">Crebit</th>
          </tr>
          <tr>
            <th>Ledger Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr>
              <td>{{ data.VendorBranchLedgerName }}</td>
              <td>{{ (data.VendorAmount + getTotalGstAmount()) | number:'1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>

    </div>
  </div>
  <div>
    <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
  </div>
</div>

  <div *ngIf="data.productEntries && data.productEntries.length === 0" class="no-products">
    <p>No products added yet.</p>
  </div>
  <div *ngIf="data.productList && data.productList.length === 0" class="no-products">
    <p>No products added yet.</p>
  </div>
</div>